import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { each, initial, last } from 'lodash';
import DateTimeDisplay from '../../../../components/date-time-display';
import ProgressBar from '../../../../components/progress-bar';
import AnswerBox from './AnswerBox';
import styles from './styles.css';

class EvidenceBox extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  replaceTokens(questionText, tokens) {
    let tokenStrings = '';
    const fTokens = tokens.map(t => `&laquo;${t}&raquo;`);
    if (fTokens.length === 1) {
      [tokenStrings] = fTokens;
    } else if (fTokens.length === 2) {
      tokenStrings = fTokens.join(' and ');
    } else if (fTokens.length > 0) {
      tokenStrings = `${initial(fTokens).join(', ')} and ${last(fTokens)}`;
    }
    return (questionText || '').replace('[loop_instance]', tokenStrings);
  }

  renderHTML(raw) {
    return <span dangerouslySetInnerHTML={{ __html: raw }} />;
  }

  renderCaptureDate() {
    const { insight } = this.props;
    const { interviews } = insight;
    let interview = null;
    if (interviews && interviews.length) {
      [interview] = interviews;
    }
    return (
      <div className="text-center" style={{ paddingBottom: 10 }}>
        <strong>
          Feedback captured from {insight.contact_name}&nbsp;
          {interview !== null &&
            <span>
              on <a href={interview.overview_url} target="_blank"><DateTimeDisplay value={interview.publish_date} format="short" /> <Fa name="external-link" /></a>
            </span>
          }
        </strong>
      </div>
    );
  }

  renderConvesation() {
    const { insight } = this.props;
    if (!insight) {
      return null;
    }
    const { questions } = insight;

    const messages = [];

    each(questions, (question) => {
      let questionText = question.question_text;
      if (question.is_looping) {
        const tokens = [];
        each(question.answers, (answer) => {
          if (answer.instance_label) {
            tokens.push(answer.instance_label);
          } else if (answer.loop_instances) {
            each(answer.loop_instances, (li) => {
              if (li.text) {
                tokens.push(li.text);
              }
            });
          }
        });
        questionText = this.replaceTokens(question.question_text, tokens);
      }


      messages.push((
        <div key={question.question_id} className={styles.fromMe}>
          <div className={styles.bubble}>
            {this.renderHTML(questionText)}
          </div>
        </div>
      ));

      const answers = [];
      if (question.answers && question.answers.length) {
        answers.push(<AnswerBox
          key={`answers-${question.question_id}`}
          className={styles.bubble}
          answers={question.answers}
          isLooping={question.is_looping}
          questionType={question.question_type}
        />);
      } else {
        answers.push((
          <div key={`${question.question_id}-empty-answer`} className={`${styles.bubble} ${styles.bubbleEmpty}`}>
            {insight.contact_name} did not response to this question.
          </div>
        ));
      }

      
      messages.push((
        <div key={`${question.question_id}-answers`} className={styles.fromThem}>
          <div>{answers}</div>
          {(question.answers && question.answers.length > 0) && <div className={styles.name}>{insight.contact_name}</div>}
        </div>
      ));
    });

    return (
      <div>
        {this.renderCaptureDate()}
        <div className={styles.chats}>
          {messages}
        </div>
      </div>
    );
  }

  render() {
    const { insight } = this.props;
    const isLoading = insight === null;
    return (
      <div>
        {isLoading && <div style={{ padding: '15px 0' }}><ProgressBar /></div>}
        {!isLoading && this.renderConvesation()}
      </div>
    );
  }
}

EvidenceBox.propTypes = {
  insight: PropTypes.shape({
    insight_statement: PropTypes.string,
    insight_id: PropTypes.string,
    contact_name: PropTypes.string,
    questions: PropTypes.arrayOf(PropTypes.shape({
      question_text: PropTypes.string,
      question_id: PropTypes.string,
      question_type: PropTypes.number,
      is_looping: PropTypes.bool,
      answers: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.number,
        text: PropTypes.string,
      })),
    })),
  }),
};
EvidenceBox.defaultProps = {
  insight: null,
};

export default EvidenceBox;
